import AnalyticDoctorLayout from "../../../containers/Statistic/analytic.doctor";
import {useAPI} from "../../../hooks/useAPI";
import {observer, useLocalObservable} from "mobx-react";
import {useContext, useEffect} from "react";
import React from "react";
import Page from "../../../components/Pages/Page";
import {formatX} from "../../../components/analytic/utils/formatX";
import {formatY} from "../../../components/analytic/utils/formatY";
import ModalsStore from "../../../components/Pages/Modals.store";
import {generateRandomString} from "../../../utils/generateRandomString";
import {API_SystemManager} from "../../../api/systemManager";
import {SystemManager_API} from "../SystemManager.API";
import {AuthContext} from "../../../context/AuthContext";
import moment from "moment";

export const PageAnalyticDoctor = observer(() => {
    const {APIRequest, loading} = useAPI()
    const userId = useContext(AuthContext)?.token?.userId
    const store = useLocalObservable(() => ({

        graph: null,
        setGraph: graph => store.graph = graph,

        list: [],
        setList: list => store.list = list,

        info: {},
        setInfo: info => store.info = info,

        dates: {
            startDate: new Date(),
            endDate: null,
            key: 'selection'
        },

        setDate: (date) => store.dates = date,

		period: "year",
        setPeriod: period => {
            store.period = period
            store.serverPeriod = ""
        },

        serverPeriod: "",
        setServerPeriod: period => store.serverPeriod = period,

        selectedId: "",
        setSelectedId: id => store.selectedId = id
    }))


    const setLayoutProps = () => {

        const info = store.info


        const blocks = {
            minimalTime: info?.min,
            maximumTime: info?.max,
            averageTime: info?.average,
            allErrors: info?.mistakes,
            allReading: info?.total,
            balance: false,
            allEarned: info?.earned,
        }
        const readingStart = {hide: true}
        const qualityControl = {checked: info?.qualityControl>0?true:false, onChange: launchQualityControl,}
        const chartTypes = {
            title: "Отработано часов",
            sortBar:
                {
                    options: [
                        {label: "Год", id: `year`, selected: "year" === store.period},
                        {label: "Месяц", id: `month`, selected: "month" === store.period},
                        {label: "Неделя", id: `week`, selected: "week" === store.period}
                    ],
                    onClick: store.setPeriod
                },
            graph: store?.graph?.length > 0 ? store.graph?.map(item => ({y: item.y, x: item.x})) : [{y: 0, x: 0}],
            formatX: (x) => {
                const customDates = ['day', 'days', "month", "week"]
                return formatX(x, customDates.includes(store.serverPeriod) ? store.serverPeriod : store.period)
            },
            formatY: (y) => formatY(y),
            onDateChange: e => {
                store.setPeriod("date")
                store.setDate(e)
            },
            date: store?.dates

        }
        const list = {
            options: store.list.map(item => ({label: item?.fio, id: item?.id})),
            selected: store.selectedId,
            optionOnClickHandler: item => store.setSelectedId(item.id),
            addOptionHandler: openModal
        }
        const breadCrumbs = [
            {link: "", title: "Активность"},
            {link: "", title: "Аналитика доктора", actual: true},
        ]

        return {
            blocks,
            readingStart,qualityControl,
            list,
            chartTypes,
            loading,
            breadCrumbs
        }
    }

//API
    const api = API_SystemManager.analytic_doctor

    const getList = async () => {
        await APIRequest(api.getDoctors(userId))
            .then(res => {
                if (res.status === 200) {
                    store.setList(res?.body?.data)
                    if (!store.selectedId && res?.body?.data?.length > 0) {
                        store.setSelectedId(res?.body?.data[0]?.id)
                    }
                }
            })
    }

    const getAnalytic = async () => {
        const start_date = moment(store.dates.startDate).format("YYYY-MM-DD")
        const end_date = moment(store.dates.endDate).format("YYYY-MM-DD")

        if (store.selectedId)
            await APIRequest(api.getStatistics(userId,store.selectedId, store.period, '', start_date, end_date || start_date))
                .then(res => {
                    if (res.status === 200) {
                        store.setInfo(res?.body?.data)
                    }
                })
    }

    const getGraph = async () => {
        const start_date = moment(store.dates.startDate).format("YYYY-MM-DD")
        const end_date = moment(store.dates.endDate).format("YYYY-MM-DD")

        await APIRequest(api.getStatistics(userId, store.selectedId, store.period, "graph", start_date, end_date ? end_date : start_date))
            .then(res => {
                if (res.status === 200) {
                    store.setServerPeriod(res?.body?.data?.type)
                    store.setGraph(res?.body?.data?.graph)
                }
            })
    }

    const launchReading = async () => {
        await APIRequest(api.launchReading(store.selectedId), null, {disableLoading: true})
            .then(res => {
                if (res.status === 200) {
                    store.setInfo({...store.info, isLaunched: res?.body?.data?.isLaunched})
                }
            })
    }
	const launchQualityControl = async () => {
        await APIRequest(api.launchQualityControl(userId, store.selectedId), null, {disableLoading: true})
            .then(res => {
                if (res.status === 200) {
                    store.setInfo({...store.info, qualityControl: res?.body?.data[0]?.is_quality_control})
                }
            })
    }

    const openModal = () => {
        const {
            addAssistant
        } = SystemManager_API.activities.assistants



        const addAssistantRequest = async (formData, assistantId) => {
            return await APIRequest(addAssistant(userId,assistantId), formData)
        }


        ModalsStore.showModal("AssistantsModal", {
                initialForm: {
                    login: generateRandomString(8),
                    password: generateRandomString(10)
                },
                roleSelectOptions: [
                    {label: 'Лаборант/Кабинет', name: 'role', value: 9},
                    {label: 'Лаборант/Машина', name: 'role', value: 10},
                    {label: 'Доктор', name: 'role', value: 6},
                ],
                disabledFields: {
                }
            },
            {
                submit(formData) {
                    return addAssistantRequest(formData)
                        .then(res => res.status === 201 && 'success')
                },
                closeHandler() {
                    getList()
                    // setRefresh(!refresh)
                }
            }
        )
    }

    useEffect(() => {
        getList()
    }, [])

    useEffect(() => {
        if (store.selectedId && store.period) {
            getAnalytic()
            getGraph()
        }
        }, [store.selectedId, store.period, store.dates.endDate])

    // useEffect(() => {
    //
    //     if (store.period === 'date'&& store.dates.endDate) {
    //         getAnalytic()
    //         getGraph()
    //     }
    // }, [store.dates.endDate])

    return (
        <Page mobile>
            <AnalyticDoctorLayout {...setLayoutProps()}/>
        </Page>

    )
})
